module.exports = __webpack_public_path__ + "static/media/furni2.e0fab552.jpg";